import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatNumber(amount: number) {
  return amount.toLocaleString('en-US');
}

export function formatCurrency(amount: number, currency: string = 'USD') {
  return amount.toLocaleString('en-US', {
    style: 'currency',
    currency,
  });
}

export function formatDate(date: string | Date) {
  if (!date) return "";
  const d = new Date(date);
  if (isNaN(d.getTime())) return "";

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function getDaysUntil(date: string | Date | null | undefined): number | null {
  if (!date) return null;
  const target = new Date(date);
  if (isNaN(target.getTime())) return null;
  target.setHours(0, 0, 0, 0);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((target.getTime() - today.getTime()) / 86400000);
}

export function slugify(input: string): string {
  if (!input) return "";
  return input
    .toString()
    .trim()
    .toLowerCase()
    .normalize('NFKD')
    // keep a-z/0-9 + Arabic letters (U+0600–U+06FF); everything else becomes a separator
    .replace(/[^a-z0-9\u0600-\u06FF]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-');
}
